
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import calendar from './calendar';
import * as time from '../js/timeformat';
var mobdate = null;
import Lunar from '../js/shouxing.js'
export default {
data(){
return{
dataList:[
{
nickname:'',
sex:1,
birthday:'',
shichen:''
}
],
num:4,
calendarShow: false,
index:null,
shichen:['子时','丑时','寅时','卯时','辰时','巳时','午时','未时','申时','酉时','戌时','亥时'],
id:'',
noneli:'11',
lunar: null,
}
},
components: {
XInput,
XButton,
Group,
Cell,
calendar,
},
watch:{
dataList:{
handler: function(newVal, oldVal) {

var reg = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");

for(let i =0;i<newVal.length;i++){
if(!reg.test(newVal[i].nickname)){
this.dataList[i].nickname = this.dataList[i].nickname.slice(0,this.dataList[i].nickname.length-1)


}
}
},
deep: true,

}
},
created: function () {
this.lunar = new Lunar();
console.log(this.lunar)
},
mounted: function () {
this.id = this.$route.query.id















mobdate = mobiscroll.date('#scroller', {

theme: 'ios',
monthNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
display: 'bottom', //显示方式 bubble bottom center inline


anchor: '#scroller',
layout: "fixed",


showLabel: true,


headerText: '{value}<br><span style="font-size:12px;color:#999" id="nongli">'+this.changeNongli("1980-1-1")+'</span>',

defaultValue:new Date(1980,1-1,1),
cssClass:'hh',
buttons: [{
text: '取消',

handler: (event, inst) => {
inst.hide();
}
}, {
text: '完成',

handler:  (event, inst) => {
this.dataList[this.index].birthday = time.dateArr(inst.getVal(true)).date;




inst.cancel();
}
}],






onChange: ((event, inst)=>{
console.log(event,inst)
this.dataList[this.index].birthday = event.valueText
this.changeNongli(this.dataList[this.index].birthday,'change')
}),
onClose: function (event, inst) {
mobdate.setVal(new Date(1980,0,1))
},
dateFormat: 'yyyy-mm-dd',
lang: 'zh',
});
mobdate.hide();
},
methods:{
changeNongli(date,type){
let newDate = date.split('-');
let [tY,tM,tD] = ['','','']
tY = parseInt(newDate[0]);
tM = parseInt(newDate[1]) - 1;
tD = parseInt(newDate[2].split(' ')[0]);
this.lunar.yueLiCalc(tY, tM + 1);
let lunarD = this.lunar.lun[tD - 1];
this.nongli = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc;
type==='change'?document.getElementById('nongli').innerText = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc:null
return this.nongli
},
showBirthday(index){
mobdate.show();
this.index = Number(index)
},
calendarClose: function(data) {
console.log('data:', data);
this.calendarShow = data.flag;
this.dataList[this.index].birthday = data.birthday

},
addUser(){
if(this.num!=0&&this.dataList[this.dataList.length-1].nickname!=''&&this.dataList[this.dataList.length-1].birthday!==''){
this.dataList.push(
{
nickname:'',
sex:1,
birthday:'',
shichen:''
}
)
this.num -=1
}else{
this.$vux.toast.text('请将信息补充完整', 'center')
}
},
deleteMore(index){
this.dataList.splice(index,1)
this.num += 1
},
submit(){
console.log(this.dataList)
this.dataList[0].user_id = this.id
this.$http.post('/wuxingMultiTest',{userinfo:this.dataList}).then(res => {
if(res.body.code===0){

this.$router.push('/moreResult?id=' + res.body.result)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/more.vue